function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(23.137255%,53.333333%,76.470588%)",
      fillOpacity: 1
    },
    d: "M 467.367188 416.84375 C 467.367188 444.746094 444.746094 467.367188 416.84375 467.367188 L 63.15625 467.367188 C 35.253906 467.367188 12.632812 444.746094 12.632812 416.84375 L 12.632812 63.15625 C 12.632812 35.253906 35.253906 12.632812 63.15625 12.632812 L 416.84375 12.632812 C 444.746094 12.632812 467.367188 35.253906 467.367188 63.15625 Z M 467.367188 416.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 207.511719 223.453125 L 247.84375 223.453125 C 269.382812 223.453125 284.285156 210.53125 284.285156 188.601562 C 284.285156 166.28125 269.382812 154.128906 247.84375 154.128906 L 207.511719 154.128906 Z M 148.761719 130.636719 C 148.761719 111.839844 159.335938 100.078125 178.914062 100.078125 L 247.84375 100.078125 C 308.160156 100.078125 345.371094 127.113281 345.371094 188.601562 C 345.371094 231.675781 312.859375 256.34375 272.90625 262.625 L 339.5 333.902344 C 344.96875 339.777344 347.316406 345.652344 347.316406 351.132812 C 347.316406 366.402344 335.179688 381.285156 317.960938 381.285156 C 310.902344 381.285156 301.503906 378.542969 295.238281 371.101562 L 208.292969 265.753906 L 207.511719 265.753906 L 207.511719 350.742188 C 207.511719 370.332031 194.980469 381.285156 178.128906 381.285156 C 161.292969 381.285156 148.761719 370.332031 148.761719 350.742188 Z M 148.761719 130.636719 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.233bf8c06006e1bd21796a512d3ede09.svg";
export { ForwardRef as ReactComponent };